<template>
  <NumeraiModal ref="modal" title="Model Invocations" :width="1100">
    <template v-slot:activator>
      <slot></slot>
    </template>
    <div class="invocations_modal_container">
      <div class="table-container">
        <table class="table">
          <thead>
            <th class="head1">Request ID</th>
            <th class="head1">Invoked At</th>
            <th class="head">Status</th>
            <th class="head">Logs</th>
          </thead>
          <tbody>
            <tr
              v-for="entry in formattedRows"
              :key="entry.requestId"
              class="unresolved"
            >
              <td>{{ entry.requestId }}</td>
              <td>{{ entry.insertedAt }}</td>
              <td class="data">{{ entry.status }}</td>
              <td v-if="entry.logStreamName != null" class="data">
                <ComputeLogsModal
                  :model-id="computeModel.model_id"
                  :log-stream-name="entry.logStreamName"
                >
                  <button
                    class="numerai-button button-tertiary
                      text-right"
                    @click="() => false"
                  >
                    <i class="v-icon material-icons button-icon"> analytics </i>
                  </button>
                </ComputeLogsModal>
              </td>
              <td v-else></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </NumeraiModal>
</template>

<script>
import NumeraiModal from '@/components/shared/NumeraiModal'
import ComputeLogsModal from '@/components/shared/ComputeLogsModal'
import _ from 'lodash'

export default {
  components: {
    NumeraiModal,
    ComputeLogsModal,
  },
  props: {
    computeModel: {
      type: Object,
      required: true,
      default: () => null,
    },
  },
  data() {
    return {
      invocationData: [],
    }
  },
  computed: {
    formattedRows() {
      // TODO: make this modal paginated instead of just returning latest 15
      let rows = _.cloneDeep(this.invocationData)
      return rows
        .sort((a, b) => (a.insertedAt < b.insertedAt ? 1 : -1))
        .slice(0, 15)
    },
  },
  watch: {
    computeModel: function() {
      this.fetchInvocations()
    },
  },
  async created() {
    await this.fetchInvocations()
  },
  methods: {
    async fetchInvocations() {
      let _details
      try {
        _details = await this.$client.invocations(this.computeModel.model_id)
      } catch (err) {
        console.error(err)
        return
      }
      this.invocationData = _details
    },
  },
}
</script>

<style scoped>
.table {
  width: 100%;
  border-collapse: collapse;
}

th {
  padding: 9px;
  padding-bottom: 10px;
}
th.head1 {
  font-size: 11px;
  font-weight: 500;
  text-transform: uppercase;
  font-family: var(--brand-font);
  color: var(--color-primary);
  text-align: left;
  white-space: nowrap;
}
th.head {
  font-size: 11px;
  font-weight: 500;
  text-transform: uppercase;
  text-align: end;
  font-family: var(--brand-font);
  color: var(--color-primary);
  white-space: nowrap;
}
td {
  font-size: 12px;
  text-decoration: none;
  padding: 9px;
  border-top: 1px solid var(--paper-border-color) !important;
}

td.data {
  text-align: end;
  font-family: var(--number-font);
  font-weight: 500;
  white-space: nowrap;
}

td.data1 {
  text-align: left;
  font-family: var(--number-font);
  font-weight: 500;
  white-space: nowrap;
}
td.true-contribution {
  color: var(--color-true-contribution);
  font-weight: 500;
}

.table-title {
  text-transform: uppercase;
}

tr:hover {
  background-color: var(--paper-background-very-subtle);
  cursor: pointer;
}

tr:hover td {
  color: var(--color-primary);
}

tr:hover td.true-contribution {
  color: var(--color-true-contribution);
}

tr.unresolved {
  color: var(--color-secondary);
}

tr.resolved td {
  /*font-weight: bold;*/
  font-weight: 500;
}

@media screen and (max-width: 1000px) {
  .table-container {
    overflow-x: scroll;
  }
}

.invocations_modal_container {
  height: 650px;
  max-height: 95vh;
}
</style>
